// extracted by mini-css-extract-plugin
module.exports = {"award":"award-module--award--1tzRb","generalFadeIn":"award-module--generalFadeIn--29FUT","emp":"award-module--emp--vB4Xa","num":"award-module--num--3QOki"};